import { Core } from "../../components/infrastructure/core";
import { BaseComponent, IBaseProps, IBaseStates } from "../../components/infrastructure/baseComponent";
import { IProperty, enmControlType, enmPropertyType } from "../../components/entityManager/interfaces";
import { RepairCenter } from "./repairCenter";
import { IRepairCase, IRepairCaseCenter } from "../../baseInfo/repairCase/interfaces";
import { IResultSet } from "../../components/infrastructure/models";
import DataForm from "../../components/entityManager/dataform";
import { Radio, RadioChangeEvent } from "antd";
import TextArea from "antd/lib/input/TextArea";
import { ChangeEvent } from "react";

interface IAssignCenterProps extends IBaseProps {
    onClose?: (args: any) => void;
    onSubmit?: (options: {
        data: any;
        url: string;
        headers?: { key: string; value: string; }[];
        contentType?: any;
        completeCallback: (result: IResultSet<any>) => void;
    }) => Promise<boolean>;
    repairCase: IRepairCase;
    repairCaseCenter?: IRepairCaseCenter;
    disabled?: boolean;
}

interface IAssignCenterStates extends IBaseStates {
    currentEntity: IRepairCaseCenter;
}

export class AssignCenter extends BaseComponent<IAssignCenterProps, IAssignCenterStates>{
    properties: IProperty[];
    constructor(props: IAssignCenterProps) {
        super(props)

        this.state = {
            isAuthorized: true,
            loading: true,
            windowSize: window.innerWidth <= 765 ? 1 : 2,
            currentEntity: {
                Id: props.repairCaseCenter?.Id ?? 0,
                RowVrsn: props.repairCaseCenter?.RowVrsn,
                RowGuid: props.repairCaseCenter?.RowGuid ?? Core.newId(),
                AdminConfirm: props.repairCaseCenter?.AdminConfirm ?? true,
                AdminDescription: props.repairCaseCenter?.AdminDescription,
                RepairCenter: props.repairCaseCenter?.RepairCenter,
                RepairCenterId: props.repairCaseCenter?.RepairCenterId,
                ModifiedProperties: [],
            } as any
        };

        this.properties = [
            {
                propertyType: enmPropertyType.boolean,
                controlType: enmControlType.template,
                dataIndex: "AdminConfirm",
                title: "درخواست مورد تأیید است؟",
                rules: [{ required: true, message: 'پاسخ اجباری است' }],
                width: "100%",
                renderControl: () => {
                    return (
                        <Radio.Group key={'AdminConfirm'}
                            buttonStyle={"solid"}
                            disabled={this.props.disabled}
                            onChange={this.onChangeAdminConfirm}
                        >
                            <Radio value={true}>تأیید</Radio>
                            <Radio value={false}>رد</Radio>
                        </Radio.Group>
                    );
                }
            },
            {
                propertyType: enmPropertyType.string,
                controlType: enmControlType.template,
                dataIndex: "AdminDescription",
                title: "توضیحات",
                //rules: [{ required: !this.state.currentEntity?.AdminConfirm, message: 'پاسخ اجباری است' }],
                rulesFunc: (currentEntity: IRepairCaseCenter) => {
                    return [
                        {
                            validator: () => {
                                if (!currentEntity.AdminConfirm && !currentEntity.AdminDescription)
                                    return Promise.reject('توضیحات اجباری است');
                                return Promise.resolve();
                            }
                        }
                    ]
                },
                width: "100%",
                renderControl: () => {
                    return (
                        <TextArea
                            disabled={this.props.disabled}
                            rows={6}
                            onChange={this.onChangeAdminDescription}
                        />
                    );
                }
            },
            {
                controlType: enmControlType.lookup,
                dataIndex: "RepairCenterId",
                width: "100%",
                title: "کارشناس تعمیر",
                //rules: [{ required: this.state.currentEntity?.AdminConfirm, message: 'پاسخ اجباری است' }],
                rulesFunc: (currentEntity: IRepairCaseCenter) => {
                    return [
                        {
                            validator: () => {
                                if (!!currentEntity.AdminConfirm && !currentEntity.RepairCenterId)
                                    return Promise.reject('کارشناس تعمیر اجباری است');
                                return Promise.resolve();
                            }
                        }
                    ]
                },
                disable: (sender: AssignCenter) => {
                    return !sender.state.currentEntity?.AdminConfirm;
                },
                visibility: (currentEntity: IRepairCaseCenter) => {
                    return !!currentEntity.AdminConfirm;
                },
                lookup: {
                    lookupComponent: RepairCenter,
                    lookupProperty: "RepairCenter",
                    lookupDisplayFields: ["Name"],
                    dropdownDisplayFields: ["Name", "ProvinceName", "CityName", "Phone", "Address", "WorkTime"],
                    showButton: false
                }
            }
        ];

    }

    submit = async () => {
        const data = {
            rowGuid: this.props.repairCase.RowGuid,
            rowVrsn: this.props.repairCase.RowVrsn,
            confirm: this.state.currentEntity?.AdminConfirm,
            repairCenterId: this.state.currentEntity?.RepairCenter?.Id,
            adminDescription: this.state.currentEntity?.AdminDescription
        };

        if (this.props.onSubmit) {
            this.setLoading(true);
            return await this.props.onSubmit({
                data,
                url: "repaircasecenter/assigncenter",
                completeCallback: result => {
                    this.setLoading(false);
                    if (result.ValidationState.Successful) {
                        this.props.onClose && this.props.onClose({});
                    }
                }
            });
        }
        else
            return Promise.resolve(true);
    };

    onChangeAdminConfirm = (e: RadioChangeEvent) => {
        const { currentEntity } = this.state;
        currentEntity.AdminConfirm = e.target.value;
        if (!currentEntity.AdminConfirm) {
            currentEntity.RepairCenter = undefined;
            currentEntity.RepairCenterId = undefined;
        }
        if (currentEntity.ModifiedProperties.indexOf("AdminConfirm") === -1)
            currentEntity.ModifiedProperties.push("AdminConfirm");
        this.setState({ currentEntity });
    };

    onChangeAdminDescription = (e: ChangeEvent<HTMLTextAreaElement>) => {
        const { currentEntity } = this.state;
        currentEntity.AdminDescription = e.target.value;
        if (currentEntity.ModifiedProperties.indexOf("AdminDescription") === -1)
            currentEntity.ModifiedProperties.push("AdminDescription");
        this.setState({ currentEntity });
    };

    virtualRender() {
        //const disableCenter = !this.state.confirm;

        return (
            <div>
                <DataForm<IRepairCaseCenter>
                    labelCol={{ xxl: 6, xl: 6, lg: 8, md: 8, sm: 10, xs: 24 }}
                    wrapperCol={{ xxl: 12, xl: 12, lg: 16, md: 16, sm: 14, xs: 24 }}
                    parent={this}
                    borderLess={true}
                    resetable={true}
                    isReadonly={this.props.disabled}
                    currentEntity={this.state.currentEntity}
                    properties={this.properties}
                    onSubmit={async () => await this.submit()}
                    onReset={() => this.props.onClose && this.props.onClose(this)}
                    onChange={(property, value) => {
                        let currentEntity = this.state.currentEntity as any;
                        if (currentEntity) {
                            if (property.dataIndex === "RepairCenterId") {
                                currentEntity[property.dataIndex!] = value ? value["Id"] : 0;
                                if (currentEntity.ModifiedProperties.indexOf("RepairCenterId") === -1)
                                    currentEntity.ModifiedProperties.push("RepairCenterId");
                            }
                        }
                        this.setState({ currentEntity });
                    }}
                    preparelookupProps={(propName, lookupProps) => {
                        if (propName === "RepairCenterId") {

                        }

                        return lookupProps;
                    }}
                />
            </div>
        );
    }
}
